export var PAYMENT_STATUSES;
(function (PAYMENT_STATUSES) {
  PAYMENT_STATUSES["PENDING"] = "PENDING";
  PAYMENT_STATUSES["SUCCESS"] = "SUCCESS";
  PAYMENT_STATUSES["FAILED"] = "FAILED";
})(PAYMENT_STATUSES || (PAYMENT_STATUSES = {}));